import { render, staticRenderFns } from "./ko-tabulka.vue?vue&type=template&id=5d856906&"
import script from "./ko-tabulka.vue?vue&type=script&lang=js&"
export * from "./ko-tabulka.vue?vue&type=script&lang=js&"
import style0 from "./ko-tabulka.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports